var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonWithHeart = function SvgPersonWithHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C4F26",
    fillRule: "evenodd",
    d: "M7.478 13.762c-2.02-1.357-3.294-3.635-3.294-6.259C4.184 3.257 7.523 0 11.95 0s7.855 3.249 7.855 7.503c0 2.628-1.239 4.903-3.272 6.259h4.423c.572 0 1.064.398 1.204.972l1.855 7.68h-.006c.189.808-.402 1.586-1.204 1.586h-9.533c.602-.522 1.305-1.167 1.885-1.894.662-.83 1.204-1.812 1.204-2.888 0-1.322-1.043-2.386-2.335-2.386-.481 0-.952.234-1.333.553-.24.204-.47.449-.67.726a3.5 3.5 0 0 0-.671-.726c-.392-.316-.852-.553-1.333-.553-1.292 0-2.335 1.066-2.335 2.386 0 1.076.542 2.058 1.204 2.888.583.727 1.294 1.372 1.886 1.894H1.24c-.813 0-1.396-.778-1.204-1.587l1.853-7.68c.142-.571.632-.971 1.204-.971z",
    clipRule: "evenodd"
  })));
};
export default SvgPersonWithHeart;